<script>
  export let day;
  export let date;
  export let hours;
  export let ptoHours;
  export let otHours;
</script>

<style>
  .header {
    width: 100%;
    border: 1px solid #b2bec3;
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    /* position: -webkit-sticky;
    position: sticky;
    top: 0;
    background-color: white; */
  }
  .day-title {
    width: 90%;
    margin: 0 auto;
    border-bottom: 3px solid grey;
  }
  .header > .subtext {
    font-size: 70%;
  }
</style>

<div class="header">
  <div class="day-title">
    {day}
    <br />
    {#if date === null}
      Empty date
    {:else}{date.substring(5, 7)}/{date.substring(8, 10)}{/if}
  </div>
  <div class="day-hours">{hours} hour{hours > 1 ? 's' : ''}</div>
  <div class="pto-hours subtext">{ptoHours} PTO hour{ptoHours > 1 ? 's' : ''}</div>
  <div class="ot-hours subtext">{otHours} OT hour{otHours > 1 ? 's' : ''}</div>
</div>
